import { ChangeDetectionStrategy, input, inject, computed, Component } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { MaterialService, MaterialType } from './material.service';

@Component({
  selector: 'app-material',
  standalone: true,
  templateUrl: './material.html',
  styleUrls: ['./material.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleCasePipe]
})
export class Material {
  zone = input.required<string>();
  protected materialService = inject(MaterialService);

  protected selection = computed(() =>
    this.materialService.getSelection(this.zone())()
  );

  protected availableTypes = computed(() =>
    this.materialService.getAvailableTypes(this.zone())()
  );

  protected availableColors = computed(() => {
    const type = this.selection().type;
    return this.materialService.getColors(type);
  });

  setType(event: Event) {
    const select = event.target as HTMLSelectElement | null;
    if (select) {
      this.materialService.setType(this.zone(), select.value as MaterialType);
    }
  }

  selectColor(code: string) {
    this.materialService.setColor(this.zone(), code);
  }
}
